// extracted by mini-css-extract-plugin
module.exports = {"network":"Network-module--network--2WqbR","name":"Network-module--name--2Hz2K","badge":"Network-module--badge--2hZof","warning":"Network-module--warning--22-Hq"};